import React from "react";
import ProviderCard from "./ProviderCard";
import Loader from "../Common/Loader";
 

const ProviderGrid = ({ providers, onSelect, loading }) => {
  return (
    <div className="w-full px-6 h-[420px] overflow-y-scroll customScrollbar">
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <Loader/>
        </div>
      ) : providers.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {providers.map((provider, index) => (
            <ProviderCard
              key={provider._id || index}
              provider={provider}
              onSelect={onSelect}
            />
          ))}
        </div>
      ) : (
        <div className="p-4 text-gray-600 text-center">No providers found.</div>
      )}
    </div>
  );
};

export default ProviderGrid;